<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :tbody-tr-class="rowClass"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @delete-items="deleteItems"
                            @new-item="addItem"
                            @row-click="detailItem"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="row" v-if="row.item.module_type != 'Safety'">
                                    <b-form-checkbox disabled></b-form-checkbox>
                                </template>
                            <template slot="gofix_table:term_type" slot-scope="row">
                                {{ row.item.term_type ? `${row.item.term_type}-term` : '' }}
                            </template>
                            <template slot="gofix_table:start_date" slot-scope="row">
                                {{ row.item.start_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:end_date" slot-scope="row">
                                {{ row.item.end_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:contract_sum" slot-scope="row">
                                {{ row.item.sum | formatMoney }}
                            </template>
                            <template slot="gofix_table:status" slot-scope="row">
                                <span class="opacity-06">{{ row.item.status }}</span>
                            </template>
                            <template slot="gofix_table:name_organization" slot-scope="row">
                                <span>{{ row.item.supplier ? row.item.supplier.name : '' }}</span>
                            </template>
                        </gofix-default-table>
                        <b-modal :no-close-on-backdrop="true" size="lg" id="modal-Contract" title="Create Project" hide-footer :centered="true" ref="modal-Contract">
                            <b-form class="pb-20">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                                label="Client Contract Name"
                                                desc="e.g. Contract with ABC"
                                                vLabel="contract_name"
                                                :filterable="false"
                                                :append-to-body="true"
                                                :required="true"
                                                show-icon-required
                                                :options="contracts"
                                                @search="searchContract"
                                                v-model="supplier.contract">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-input 
                                            label="Project Reference Number" 
                                            v-model="supplier.contract_reference_number" 
                                            show-icon-required
                                            required
                                            autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="12">
                                        <gofix-form-input 
                                            label="Project Name" 
                                            v-model="supplier.contract_title" 
                                            show-icon-required
                                            required
                                            autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <!-- <b-col md="12">
                                        <gofix-form-dropdown
                                            label="Project Description"
                                            vLabel="reference_value_text"
                                            :reduce="option => option.reference_value_text"
                                            v-model="supplier.description"
                                            :options="project_descriptions">
                                        </gofix-form-dropdown>
                                    </b-col> -->
                                    <b-col md="12">
                                        <gofix-form-dropdown
                                                label="Supplier"
                                                vLabel="name"
                                                :filterable="false"
                                                :append-to-body="true"
                                                :required="true"
                                                show-icon-required
                                                :options="clients"
                                                @search="searchOrganization"
                                                v-model="supplier.supplierObj">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="12">
                                        <gofix-form-dropdown
                                            label="Project Manager"
                                            vLabel="name"
                                            required
                                            show-icon-required
                                            @search="(search, loading) => searchSafetyUsers(search, loading, 'safety_project_managers')"
                                            :reduce="option => option.id"
                                            v-model="supplier.safety_project_manager_id"
                                            :options="safety_project_managers">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                            label="Project IC"
                                            vLabel="name"
                                            @search="(search, loading) => searchSafetyUsers(search, loading, 'safety_project_ics')"
                                            :reduce="option => option.id"
                                            v-model="supplier.safety_project_ic_id"
                                            :options="safety_project_ics">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                            label="Project Director"
                                            vLabel="name"
                                            @search="(search, loading) => searchSafetyUsers(search, loading, 'safety_project_directors')"
                                            :reduce="option => option.id"
                                            v-model="supplier.safety_project_director_id"
                                            :options="safety_project_directors">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="12">
                                        <gofix-form-input 
                                            label="Address" 
                                            v-model="supplier.safety_address" 
                                            autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="12">
                                        <gofix-form-input 
                                            label="Project Department Head Emails" 
                                            v-model="supplier.project_department_head_emails" 
                                            autocomplete="off"
                                            desc="Separate multiple emails with comma">
                                        </gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-input-date
                                            required
                                            show-icon-required
                                            v-model="supplier.start_date"
                                            label="Start Date">
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-input-date
                                            required
                                            show-icon-required
                                            :minDate="new Date()"
                                            v-model="supplier.end_date"
                                            label="End Date">
                                        </gofix-form-input-date>
                                    </b-col>
                                </b-row>
                            </b-form>
                            <b-button-group class="d-block text-right">
                                <gofix-button label="SUBMIT" @click="saveSupplier" :loading="isAction" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                        
                        <b-button @click="addItem" v-if="$checkRole($accessModule.safety_app_subcontractor, 'create')" class="enabledBtn"><img src="img/enabledBtn.png" alt="" /></b-button>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'
    import { mapGetters } from 'vuex';

    import moment from 'moment';

    export default {
        name: 'supplier-contract-list',
        components: {},
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['safety_projects']));
            return {
                tableConfig:{
                    name: 'safety-app-administrator-project-listing',
                    controls:{
                        create: this.$checkRole(this.$accessModule.safety_app_subcontractor, 'create'),
                        delete: this.$checkRole(this.$accessModule.safety_app_subcontractor, 'delete'),
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems:[],
                contracts : [],
                clients: [],
                supplier: {
                    contract_id : '',
                    client_id: '',
                    sor_adjustment: '',
                    contract: null,
                    supplierObj:null,
                    contract_title: null,
                    contract_reference_number: null,
                    project_type: null,
                    term_type: "base",
                    module_type: 'Safety',
                    project_department_head_emails: null,
                    description: null,
                    start_date: null,
                    end_date: null,
                    safety_project_manager_id: null,
                    safety_project_ic_id: null,
                    safety_project_director_id: null,
                    safety_address: null
                },
                isAction : false,
                adjustmentMark: [
                    {
                        value: 'up',
                        label: 'Mark Up'
                    },
                    {
                        value: 'down',
                        label: 'Mark Down'
                    }
                ],
                type: {
                    value: 'up',
                    label: 'Mark Up'
                },
                projectTypes: [],
                safety_project_managers: [],
                safety_project_ics: [],
                safety_project_directors: [],
                project_descriptions: [],
            }
        },
        mixins: [validationMixin],
        validations: {
            supplier: {
                contract_id: {
                    required
                }
            }
        },
        filters: {
            showDateTerm (item, showDate) {
                let terms = item.contract_terms;
                if(terms.length > 1) {
                    for(let i=0; i < terms.length; i++) {
                        if(terms[i].start_date && terms[i].end_date) {
                            let start_date = moment(terms[i].start_date, "YYYY-MM-DD");
                            let end_date = moment(terms[i].end_date, "YYYY-MM-DD");
                            if (moment().isBetween(start_date, end_date, null, '[]')) {
                                if (showDate == 1) {
                                    return end_date.format("DD.MM.YYYY");
                                }
                                if(showDate == 2) {
                                    return terms[0].start_date ? moment(terms[0].start_date).format("DD.MM.YYYY") : '';
                                }
                                return terms[i].term_type + '-term';
                            }
                        }
                    }
                }

                if(terms.length == 1) {
                    if (showDate == 1) {
                        return terms[0].end_date ? moment(terms[0].end_date).format("DD.MM.YYYY") : '';
                    }
                    if(showDate == 2) {
                        return terms[0].start_date ? moment(terms[0].start_date).format("DD.MM.YYYY") : '';
                    }
                    return terms[0].term_type+'-term';
                }
            }
        },
        watch: {
            "supplier.contract": function(val) {
                this.supplier.contract_id = (val && val.hasOwnProperty('id')) ? val.id : null;
            },
            "supplier.supplierObj": function(val) {
                this.supplier.client_id = (val && val.hasOwnProperty('id')) ? val.id : null;
            },
            "supplier.term_type": function(val) {
                if(val == 'base') {
                    this.supplier.contract_title = this.supplier.description = null
                }

                if(val == 'project') {
                    this.supplier.sor_adjustment = null
                    this.type = {
                        value: 'up',
                        label: 'Mark Up'
                    };
                }
                
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        async created(){
            this.getClientContract();
            this.getOrganizations();
            // this.getProjectDescriptions();
            this.loadSafetyUser().then(users => {
                this.safety_project_managers = users;
                this.safety_project_ics = users;
                this.safety_project_directors = users;
            });
        },
        methods:{
            rowClass(item) {
                if (item && item.module_type != 'Safety') {
                    return 'bg-gray-e9e';
                }
                return null;
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.contracts;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of supplier clients", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("ContractController/deleteSupplierContract", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'supplier_contract'))
                    })
                    .catch(err =>{
                        console.error("Got nothing from server. Prompt user to check internet connection and try again")
                    });
            },
            async getClientContract(filter = null) {
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
                .then(response => {  
                    this.contracts = response.data; 
                }).catch(error => {
                    console.log(error);
                })
            },
            searchContract(search, loading){
                this.contracts = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getClientContract({ contract_name: search });
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
            async getOrganizations(search) {
                await this.$store.dispatch( 'OrganizationController/getItemsNoCommit', {
                    page: 1, 
                    isCMS: 1,
                    filter: { 
                        name: { type: "text", value: search, function: "ilike", with: [] },
                        is_supplier: { type: 'boolean', value: true },
                        is_safety: { type: 'boolean', value: true },
                    }, 
                    limit: 100
                })
                .then(response => {
                    this.clients = response.data.data.items;
                })
                .catch(err=>{ 
                    console.log(err);
                })
            },
            searchOrganization(search, loading){
                this.clients = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOrganizations(search);
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }                    
                }, 500);
            },
            addItem() {
                this.supplier = {
                    contract_id : '',
                    client_id: '',
                    sor_adjustment: '',
                    contract: null,
                    supplierObj: null,
                    contract_title: null,
                    contract_reference_number: null,
                    project_type: null,
                    term_type: "base",
                    module_type: 'Safety',
                    project_department_head_emails: null,
                    description: null,
                    start_date: null,
                    end_date: null,
                    safety_project_manager_id: null,
                    safety_project_ic_id: null,
                    safety_project_director_id: null,
                    safety_address: null
                };
                this.supplier.contract = this.ClientContractID ? this.ClientContractID : null;
                this.$refs['modal-Contract'].show()
            },
            detailItem(item) {
                if(item.module_type != 'Safety') return;
                this.$router.push(`/v2/safety-app-project/${item.id}`)
            },
            saveSupplier() {
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    if(!this.supplier.contract) {
                        return this.$alertNotification("Client contract is required", "danger");
                    }

                    if(!this.supplier.supplierObj) {
                        return this.$alertNotification("Supplier is required", "danger");
                    }

                    if(!this.supplier.contract_title) {
                        return this.$alertNotification("Project name is required", "danger");
                    }

                    if(!this.supplier.contract_reference_number) {
                        return this.$alertNotification("Project reference number is required", "danger");
                    }

                    if(this.supplier.safety_project_manager_id == null) {
                        return this.$alertNotification("Project Manager is required", "danger");
                    }

                    if(!this.supplier.start_date) {
                        return this.$alertNotification("Start date is required", "danger");
                    }

                    if(!this.supplier.end_date) {
                        return this.$alertNotification("End date is required", "danger");
                    }

                    if(moment(this.supplier.end_date).isBefore(moment(this.supplier.start_date))) {
                        return this.$alertNotification("End date must be after start date", "danger");
                    }

                    // if(this.supplier.term_type == 'project') {
                    //     if(!this.supplier.contract_reference_number) {
                    //         return this.$alertNotification("Contract reference number is required", "danger");
                    //     }
                    // }

                    this.supplier.contract_id = (this.supplier.contract && this.supplier.contract.hasOwnProperty('id')) ? this.supplier.contract.id : ''
                    let request = JSON.parse(JSON.stringify(this.supplier));
                    // request.sor_adjustment = request.sor_adjustment ? request.sor_adjustment.replace("%", "") : ''
                    // if(request.sor_adjustment != '' && this.type.value === 'down'){
                    //     if(request.sor_adjustment > 100) {
                    //         return this.$alertNotification("Mark Down: can't input SOR Adjustment > 100%", "danger");
                    //     }
                    //     request.sor_adjustment = request.sor_adjustment
                    // }
                    // request.type = this.type ? this.type.value : 'down'

                    if(request.project_department_head_emails) {
                        const emails = request.project_department_head_emails.split(",").map(email => email.trim());
                        for(let i = 0; i < emails.length; i++) {
                            if(!this.emailValidationCheckFormat(emails[i])) {
                                return this.$alertNotification(`Please enter a valid email address for Department Head Email: ${emails[i]}`, "danger");
                            }
                        }
                        request.project_department_head_emails = emails
                    }

                    request.start_date = request.start_date ? moment(request.start_date).format("YYYY-MM-DD") : null;
                    request.end_date = request.end_date ? moment(request.end_date).format("YYYY-MM-DD") : null;

                    this.$v.supplier.$touch()
                    if(!this.$v.supplier.$error){
                        this.isAction = true
                        this.$store.dispatch('ContractController/CreateSupplierContract', request)
                            .then( async (response) => {
                                if (response.data.status == 200 && response.data.data.code == 400) {
                                    this.$refs['modal-Contract'].hide()
                                    this.isAction = false
                                    return this.$alertNotification(response.data.data.message, "danger");
                                }
                                if (response.data.status == 200) {
                                    this.$refs['modal-Contract'].hide()
                                    this.$refs.gofixTable.reloadTableItems();
                                    await this.$alertNotification(this.$notificationV2('adding', 'supplier_contract'));
                                }
                                this.isAction = false
                            })
                            .catch(error => { this.isAction = false });
                    }
                }, 500)
            },
            emailValidationCheckFormat(email_address){
                if(email_address && email_address != ''){
                    let pattern = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
                    let result = pattern.test(email_address);
                    return result;
                }
                return true;
            },
            loadSafetyUser(search){
                return new Promise((resolve, reject) => {
                    this.$store.dispatch("v2UserController/getListUser2", {
                        filter: {
                            type_user:"all-safety",
                            name: { type: "text", value: search, function: "like", with: [] },
                            active:{ type: "boolean", value: true },
                            is_safety: { type: "boolean", value: true },
                        },
                        isCMS: 1,
                        page: 1,
                        limit: 100,
                        sortColumn: "name",
                        sortDirection: "asc",
                    }).then(response => {
                        resolve(response.items);
                    })
                    .catch(err=>{
                        console.log(err)
                        reject(err);
                    })
                })
            },
            searchSafetyUsers(search, loading, userType){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.loadSafetyUser(search).then(safetyUsers => {
                        this[userType] = safetyUsers;
                        loading(false);
                    })
                }, 500);
            },
            getProjectDescriptions(){
                let filter = {reference_type: "Safety Project Description"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.project_descriptions = response.items;
                    })
            },
        }
    }
</script>
<style lang="scss">
    .switch-module {
        .custom-control {
            padding-right: 1.5rem;
        }
    }
    #modal-Contract {
        .modal-dialog {
            &.modal-lg {
                max-width: 800px;
            }
        }
    }
</style>